module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "background"
  }, [_c('x-header', {
    attrs: {
      "left-options": {
        showBack: false
      },
      "title": "已属于如下企业"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "numberCorp"
  }, [_vm._v("你已经属于" + _vm._s(this.corpList.length) + "家企业")]), _vm._v(" "), _c('ul', _vm._l((_vm.corpList), function(item) {
    return _c('li', {
      key: item.corpId
    }, [_vm._v(_vm._s(item.corpName))])
  }), 0)], 1), _vm._v(" "), (_vm.isContinue) ? _c('kp-bottom-btn', {
    attrs: {
      "title": "继续注册"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push('/register')
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53c3387e","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/corpList.vue
// module id = 325
// module chunks = 1